<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="container">
  <h1>BeerBrawl🍻</h1>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
